module.exports = __webpack_public_path__ + "static/media/Kontakt.d232f531.jpg";